import { ArrowUp } from "lucide-react";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="agency-footer" className="relative pt-24 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-16 border-b gold-border-subtle">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <Logo size={52} />
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/80">San Diego, California</p>
                <p className="text-zinc-400 text-sm mt-1">Architectural web design for high-performing trade businesses.</p>
              </div>
            </div>
          </div>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-gold transition-colors"
          >
            Back to top
            <span className="w-10 h-10 rounded-full border border-zinc-700 flex items-center justify-center group-hover:border-gold group-hover:-translate-y-1 transition-all duration-300">
              <ArrowUp size={15} />
            </span>
          </button>
        </div>

        <div className="py-12 select-none pointer-events-none" aria-hidden="true">
          <span className="font-serif font-light text-[13vw] lg:text-[9rem] leading-none gold-text opacity-[0.14] block tracking-tight whitespace-nowrap">
            TRADESITE PRO
          </span>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © 2026 TradeSite Pro. Portfolio projects are demonstration concepts.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Crafted in obsidian & gold.
          </p>
        </div>
      </div>
    </footer>
  );
}
